
import { serializable, alias, primitive } from 'serializr';

export class YearStatus {

    @serializable(alias('scope1_status', primitive()))
    scope1Status?: boolean;

    @serializable(alias('scope2_status', primitive()))
    scope2Status?: boolean;

    @serializable(alias('scope3_status', primitive()))
    scope3Status?: boolean;

    @serializable(alias('revenue', primitive()))
    revenue?: number | null;

    @serializable(alias('revenue_unit', primitive()))
    revenueUnit?: string | null;

    @serializable(alias('revenue_status', primitive()))
    revenueStatus?: boolean;

}